var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.type == 'regular')?_c('img',{attrs:{"src":require("../../assets/img/Springter_Logo_Color_RGB-21.svg"),"alt":"Logo Springter"}}):(_vm.type == 'white')?_c('img',{attrs:{"src":require("../../assets/img/Forward_Manual_v3-24.svg"),"alt":"Logo Springter"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-315fd38a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Logo.vue
// module id = bwDT
// module chunks = 1